import { useQuery } from '@tanstack/react-query';

type BackgroundProcessStatus = 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'FAILED';

type MeetingAgenda = {
  markdown: string;
  fileId: number;
  backgroundProcess?: {
    id: string;
    status: BackgroundProcessStatus;
    status_message?: string;
  };
};

type UseCalendarEventMeetingAgendaResult = {
  meetingAgenda: MeetingAgenda | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
};

type Props = {
  eventId: string;
  enabled?: boolean;
};

export const useCalendarEventMeetingAgenda = ({
  eventId,
  enabled = false,
}: Props): UseCalendarEventMeetingAgendaResult => {
  const { data, isFetching, isError, error, refetch } = useQuery<MeetingAgenda>({
    queryKey: ['calendar-events', eventId, 'meeting-agenda'],
    enabled,
    retry: false,
    refetchInterval: query => {
      const status = query.state.data?.backgroundProcess?.status;
      if (status === 'PENDING' || status === 'PROCESSING') {
        return 2000;
      }
      return false;
    },
  });

  return {
    meetingAgenda: data,
    isLoading: isFetching,
    isError,
    error,
    refetch,
  };
};
